const CDN_IMG = "";
var baseUrl = "";
var img_url = "";
var h5 = "";
if (window.location.hostname == "site.jianyunkeji.net") {
	//测试服环境
	baseUrl = 'http://test.jianyunkeji.net'
	img_url = 'http://cdn.jianyunkeji.net' //测试服CDN地址
	h5 = window.location.protocol + "//site.jianyunkeji.net"
} else {
	baseUrl = window.location.protocol + "//h5.jianyunkeji.cn";
	h5 = window.location.protocol + "//www.jianyunkeji.cn"
	img_url = window.location.protocol + '//cdn.jianyunkeji.cn' //正式服CDN地址
}

function timetrans(date) {
	var date = new Date(date * 1000);
	var Y = date.getFullYear() + '-';
	var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate()) + ' ';
	var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	return Y + M + D + h + m + s;
}
export default {
	h5, //h5
	baseUrl, //公共接口地址
	CDN_IMG, //公共图片地址
	img_url, //图片地址
	timetrans, // 时间戳转化为时间
}


// WEBPACK FOOTER //
// ./src/api/globel_v.js